export default "__VITE_ASSET__BU9Lb7xi__"